"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.genericCashBalanceFeedHandler = exports.mapCsvToBorrowerCashBalancesFeed = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
// standard borrower cash balance feed map
const mapCsvToBorrowerCashBalancesFeed = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    const dbRows = lodash_1.default.map(csvArray, (row) => {
        // NOTE: we only reference the balance and balance_type columns from the csv file.
        // TODO: make a tape-builder receipe for this and remove hard code cash balance mapping functions.
        const borrowerCashBalanceRecord = {
            id: (0, uuid_1.v4)(),
            borrowerId,
            creditFacilityId,
            reportingDate,
            borrowerAccountType: row.balance_type,
            balance: Number(row.balance),
            fileVersion,
        };
        return borrowerCashBalanceRecord;
    });
    return lodash_1.default.map(dbRows, (row) => lodash_1.default.mapValues(row, common_1.utils.cleanStrForDb));
};
exports.mapCsvToBorrowerCashBalancesFeed = mapCsvToBorrowerCashBalancesFeed;
const genericCashBalanceFeedHandler = ({ borrowerId, csvArray, reportingDate, fileVersion, creditFacilityId, }) => {
    return (0, exports.mapCsvToBorrowerCashBalancesFeed)({
        borrowerId,
        csvArray,
        reportingDate,
        fileVersion,
        creditFacilityId,
    });
};
exports.genericCashBalanceFeedHandler = genericCashBalanceFeedHandler;
//# sourceMappingURL=mapCsvToBorrowerCashBalancesFeed.js.map